module.exports = __webpack_public_path__ + "static/media/icon_minus.52a4f5b3.svg";